import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { ScheduledUpcomingInterviewsListType } from "../../../redux/thinksToDo/thinksToDoType";
import {
  currentDate,
  formatDate,
  formatDateAndTimeWithoutLocal,
  formatDateInYear,
} from "../../../utils/commonFunctions";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import { CircularAvatar } from "../../commons";
import moment from "moment";

type AppProps = {
  tableHeader: [] | TableHeadersType[];
  data: ScheduledUpcomingInterviewsListType[] | [];
  handleFeedBackModal: (data?: string) => void;
};

const AllInterviewTableListData = ({
  tableHeader,
  data,
  handleFeedBackModal,
}: AppProps) => {
  return (
    <>
      {data && data?.length > 0
        ? data?.map((el: ScheduledUpcomingInterviewsListType) => {
         
          let interviewDate=new Date(el?.interview_details?.interview_round_details[
            el?.interview_details?.interview_round_details?.length - 1
          ]?.interview_date_and_time)
          let currentDate=new Date()
          let interviewDateLocal = new Date(+interviewDate - (5 * 60 + 30) * 60 * 1000);
 
            
            let overDueCheck = interviewDateLocal.getTime() < currentDate.getTime();

            return (
              <tr>
                {tableHeader &&
                  tableHeader?.length > 0 &&
                  tableHeader?.map((item: any) => {
                    if (item.value === "interview_date_time") {
                      return (
                        <td
                          className="text-start"
                          style={{ minWidth: "180px" }}
                        >
                          <div>
                            {formatDateAndTimeWithoutLocal(
                              el?.interview_details?.interview_round_details[
                                el?.interview_details?.interview_round_details
                                  ?.length - 1
                              ]?.interview_date_and_time?.toString()
                            )}
                          </div>
                          {el?.interview_details?.interview_round_details[
                            el?.interview_details?.interview_round_details
                              ?.length - 1
                          ]?.is_feedback_submited === false && (
                            <div className={overDueCheck ? `mt-2` : ""}>
                              {overDueCheck ? (
                                <span
                                  style={{ borderRadius: "16px" }}
                                  className="status-Pending"
                                >
                                  Overdue
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </td>
                      );
                    } else if (item.value === "candidate_name") {
                      return (
                        <td className="text-start">
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "3%" }}
                          >
                            <div>
                              <CustomizedAvatar
                                name={`${el?.name}`}
                                image={el?.profile_pic?.file_url}
                                style={{ width: "36px", fontSize: "17px" }}
                              />
                            </div>
                            <div>
                              <p
                                className="mt-0 mb-1"
                                style={{ color: "#6e7491" }}
                              >
                                <span
                                  className="mb-1"
                                  style={{
                                    color: "#262a44",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                  }}
                                >
                                  {el?.name}
                                </span>
                                <br></br>

                                {`${el?.email}`}
                                <br></br>
                                {el?.phone_number}
                              </p>
                            </div>
                          </div>
                        </td>
                      );
                    } else if (item.value === "applied_for") {
                      return (
                        <td className="text-start">
                          {el?.position_details?.job_position?.name}
                        </td>
                      );
                    } else if (item.value === "application_date") {
                      return (
                        <td className="text-start">
                          {formatDate(el?.interview_details?.application_date)}
                        </td>
                      );
                    } else if (item.value === "job_location") {
                      return (
                        <td className="text-start">
                          {el?.position_details?.job_location?.name}
                        </td>
                      );
                    } else if (item.value === "recruiter") {
                      return (
                        <td
                          className="text-start"
                          style={{ minWidth: "180px" }}
                        >
                          {el?.position_details?.recruiter?.first_name ? (
                            <div className="d-flex align-items-center">
                              <CircularAvatar
                                name={`${
                                  el?.position_details?.recruiter?.first_name +
                                  " " +
                                  el?.position_details?.recruiter?.last_name
                                }`}
                                image={
                                  el?.position_details?.recruiter.profile_pic
                                }
                              />
                              <div className="ml-2">
                                {el?.position_details?.recruiter?.first_name +
                                  " " +
                                  el?.position_details?.recruiter?.last_name}
                              </div>
                            </div>
                          ) : (
                            "--/--"
                          )}
                        </td>
                      );
                    } else if (item.value === "progress") {
                      return (
                        <td
                          className="text-start"
                          style={{ minWidth: "180px" }}
                        >
                          <span
                            className={
                              el?.position_details?.progress ===
                                "New Application" ||
                              el?.position_details?.progress ===
                                "Intial Screening"
                                ? "newApplication"
                                : el?.position_details?.progress ===
                                    "Phone Screening" ||
                                  el?.position_details?.progress ===
                                    "Virtual" ||
                                  el?.position_details?.progress ===
                                    "First Interview" ||
                                  el?.position_details?.progress ===
                                    "Technical Interview" ||
                                  el?.position_details?.progress ===
                                    "Interviewing"
                                ? "phoneScreening"
                                : el?.position_details?.progress ===
                                    "Offer Pending" ||
                                  el?.position_details?.progress ===
                                    "To Be Reviewed"
                                ? "pending"
                                : el?.position_details?.progress ===
                                    "Offer Rejected" ||
                                  el?.position_details?.progress ===
                                    "Application Rejected" ||
                                  el?.position_details?.progress ===
                                    "Over Qualified" ||
                                  el?.position_details?.progress ===
                                    "Future Consideration" ||
                                  el?.position_details?.progress ===
                                    "Over Budget" ||
                                  el?.position_details?.progress === "Postponed"
                                ? "rejected"
                                : el?.position_details?.progress ===
                                    "Offer Sent" ||
                                  el?.position_details?.progress ===
                                    "Offer Accepted" ||
                                  el?.position_details?.progress ===
                                    "Pay Approval" ||
                                  el?.position_details?.progress ===
                                    "Final Round"
                                ? "sent"
                                : el?.position_details?.progress ===
                                    "Accepted but Withdrawn" ||
                                  el?.position_details?.progress ===
                                    "Application on Hold"
                                ? "onhold"
                                : ""
                            }
                          >
                            {el?.position_details?.progress}
                          </span>
                        </td>
                      );
                    } else if (item.value === "action") {
                      return (
                        <td className="text-start">
                          <div>
                            <button
                              className={`btn w-100 ${
                                overDueCheck &&
                                el?.interview_details?.interview_round_details[
                                  el?.interview_details?.interview_round_details
                                    ?.length - 1
                                ]?.is_feedback_submited === false
                                  ? "btn-primary"
                                  : "btn-outline"
                              }`}
                              onClick={() => handleFeedBackModal(el?._id)}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {overDueCheck &&
                              el?.interview_details?.interview_round_details[
                                el?.interview_details?.interview_round_details
                                  ?.length - 1
                              ]?.is_feedback_submited === false
                                ? "Submit Feedback"
                                : "View Feedback"}
                            </button>
                          </div>
                        </td>
                      );
                    }
                  })}
              </tr>
            );
          })
        : ""}
    </>
  );
};

export default AllInterviewTableListData;
